import {listAddress} from "../../crud/address.crud";
import {put, takeLatest} from "redux-saga/effects";
export const actionTypes = {
    ADDRESS_ADDED: "ADDRESS_ADDED",
    ADDRESS_ADDED_SUCCESS: "ADDRESS_ADDED_SUCCESS",
    ADDRESS_UPDATED: "ADDRESS_UPDATED",
    ADDRESS_UPDATED_SUCCESS: "ADDRESS_UPDATED_SUCCESS"
};

const initialAuthState = {
    listData: undefined
};

export const reducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.ADDRESS_ADDED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        case actionTypes.ADDRESS_UPDATED_SUCCESS:
            {
                const {listData} = action.payload;
                return {listData};
            }
        default:
            return state;
    }
};

export const actions = {
    addressAdded: ({skip, limit}) => ({
        type: actionTypes.ADDRESS_ADDED,
        payload: {
            skip,
            limit
        }
    }),
    addressUpdated: ({skip, limit}) => ({
        type: actionTypes.ADDRESS_UPDATED,
        payload: {
            skip,
            limit
        }
    })
};

export function * saga() {
    yield takeLatest(actionTypes.ADDRESS_ADDED, function * addressAdded(action) {
        const {skip, limit} = action.payload;
        const listData = yield listAddress({skip, limit});

        yield put({type: actionTypes.ADDRESS_ADDED_SUCCESS, payload: {
                listData
            }});
    });

    yield takeLatest(actionTypes.ADDRESS_UPDATED, function * addressUpdated(action) {
        const {skip, limit} = action.payload;
        const listData = yield listAddress({skip, limit});

        yield put({type: actionTypes.ADDRESS_UPDATED_SUCCESS, payload: {
                listData
            }});
    });
}
